import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './ConsentPage.css';

const ConsentPage = () => {
  const { req_id } = useParams();
  const navigate = useNavigate();

  const handleConsent = () => {
    navigate(`/redirect/${req_id}`);
  };

  return (
    <div className="consent-container">
      <div className="consent-box">
        <h1>DigiLocker Access Consent</h1>
        <p>
          You are about to grant EarthID access to your DigiLocker account to verify and retrieve
          requested documents like Aadhaar, PAN, etc.
        </p>
        <ul>
          <li>Your documents will be securely accessed via DigiLocker.</li>
          <li>They will be used only for verification purposes.</li>
          <li>Access is one-time and data will be securely transmitted.</li>
        </ul>
        <button className="agree-button" onClick={handleConsent}>Agree & Continue</button>
      </div>
    </div>
  );
};

export default ConsentPage;
